//libs
import { DialogTitle } from "@headlessui/react";
import clsx from "clsx";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";

export default function CheckListModal({
  tender,
  open,
  setOpen,
  checklist,
  setChecklist,
  isSubmitting,
  handleTenderProposalSubmit,
}) {
  const allChecklist = tender?.publication_check_list;

  const toggleChecklist = (key) => {
    if (checklist.includes(key)) {
      setChecklist((prev) => prev.filter((check) => check !== key));
    } else {
      setChecklist((prev) => [...prev, key]);
    }
  };

  const isChecked = (key) => {
    return checklist.includes(key);
  };

  const isDisabled = checklist.length === 0 || isSubmitting;

  return (
    <ModalDialog open={open} setOpen={setOpen}>
      <div className="space-y-6">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Submit your Tender
        </DialogTitle>
        <h4>Final checklist before you submit your tender</h4>
        <fieldset>
          <legend className="sr-only">Checklist</legend>
          <div className="space-y-2">
            {Object.entries(allChecklist).map(([key, value]) => (
              <label
                htmlFor={key}
                className={clsx(
                  "relative flex items-start pb-4 pt-3.5 px-4 rounded-md ring-1 ring-gray-200",
                  { "ring-2 ring-teal-700": isChecked(key) }
                )}
                key={key}
              >
                <div className="min-w-0 flex-1 text-sm leading-6">
                  <div className="font-medium text-gray-900">
                    {value}
                  </div>
                  {/* <p id="checklist-description" className="text-gray-500">
                    {value}
                  </p> */}
                </div>
                <div className="ml-3 flex h-6 items-center">
                  <input
                    id={key}
                    name={key}
                    type="checkbox"
                    checked={!!isChecked(key)}
                    onChange={(e) => toggleChecklist(key)}
                    aria-describedby="checklist-description"
                    className="h-4 w-4 rounded border-gray-300 text-teal-600"
                  />
                </div>
              </label>
            ))}
          </div>
        </fieldset>
        <div className="sm:flex gap-2">
          <Button
            type="submit"
            
            disabled={isDisabled}
            onClick={handleTenderProposalSubmit}
          >
            Submit
          </Button>
          <button
            type="button"
            data-autofocus
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalDialog>
  );
}
